import Controller from '../components/Controller';
import VectorLayer from '../layer/VectorLayer';

/**
 * 反馈控制器,通过本类管理来对Feedback对象和FeedbackLayer进行操作.
 */
export default class FeedbackController extends Controller {
    /**
     * 将控制器添加到地图对象时调用
     * @param {Object}      map map对象
     * @returns {undefined}
     */
    onAdd(map) {
        super.onAdd(map);

        if (map) {
            this._layer = new VectorLayer('_internal_feedback', { selectable: false, zIndex: 999 }).addTo(map);
            this._map.whenReady(this._layer.bringToFront, this._layer);
        }
    }

    /**
     * 向elements属性中添加反馈,并按照priority重新排序.
     * @param {Object} feedback - 增加的反馈对象
     * @return {undefined}
     */
    add(feedback) {
        super.add(feedback);

        // 按优先级排序
        this.elements.sort((a, b) => a.options.priority - b.options.priority);
    }

    /**
     * 是否可用
     */
    isValid() {
        return !!this._map && !!this._layer;
    }

    /**
     * 从elements属性中添删除指定的反馈对象.
     * @param {Object} feedback - 要删除的反馈对象
     * @return {undefined}
     */
    del(feedback) {
        const existFeedback = this.elements.find(item => item === feedback);

        if (!existFeedback) {
            return;
        }

        existFeedback.setFeedbackController(null);

        this.elements = this.elements.filter(item => item !== feedback);
    }

    /**
     * 刷新反馈，全部重绘
     * @return {undefined}
     */
    refresh() {
        if (!this.isValid()) {
            throw new Error('FeedbackController未绑定到Map上');
        }

        const drawItems = [];
        this.elements.forEach(fb => {
            if (fb.enabled()) {
                drawItems.push(...fb.getItems());
            }
        });

        this._layer.clear();
        this._layer.add(drawItems);
    }
}
